import { render } from "./AddHuviring.vue?vue&type=template&id=3156c59f&scoped=true"
import script from "./AddHuviring.vue?vue&type=script&lang=js"
export * from "./AddHuviring.vue?vue&type=script&lang=js"

import "./AddHuviring.vue?vue&type=style&index=0&id=3156c59f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3156c59f"]])

export default __exports__